import { createSectionTitle, createSummaryTitle, parseHtmlContent } from '../utils';

export const renderReviewOfSystems = (data, title) => {
  const content = [createSectionTitle(title)];

  // Handle noDetails case
  if (data && data.noDetails) {
    content.push({
      text: 'No details',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
    return content;
  }

  // Helper function to check if systems data is meaningful
  const hasValidSystemsData = (data) => {
    if (!data || typeof data !== 'object') return false;

    const hasSystems =
      data.systems &&
      Object.keys(data.systems).some((system) => {
        const systemData = data.systems[system];
        return (
          systemData.responses &&
          Array.isArray(systemData.responses) &&
          systemData.responses.some((response) => response && response.trim() !== '')
        );
      });

    const hasNarrative = data.narrative && data.narrative.trim() !== '';

    return hasSystems || hasNarrative;
  };

  // Check if there's any meaningful data to display
  if (!hasValidSystemsData(data)) {
    content.push({
      text: 'No data',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
    return content;
  }

  if (data.systems) {
    Object.keys(data.systems).forEach((system) => {
      const systemData = data.systems[system];
      // Only show systems with meaningful responses
      if (
        systemData.responses &&
        systemData.responses.length > 0 &&
        systemData.responses.some((response) => response && response.trim() !== '')
      ) {
        const validResponses = systemData.responses.filter(
          (response) => response && response.trim() !== ''
        );
        if (validResponses.length > 0) {
          content.push({
            text: [
              { text: `${system.charAt(0).toUpperCase() + system.slice(1)}: `, bold: true },
              { text: validResponses.join(', ') },
              ...(systemData.timing ? [{ text: ` (${systemData.timing})` }] : [])
            ],
            margin: [0, 5, 0, 0]
          });
        }
      }
    });
  }

  // Show narrative if it exists
  if (data.narrative && data.narrative.trim() !== '') {
    content.push(createSummaryTitle());
    content.push({
      text: parseHtmlContent(data.narrative),
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
  }

  // If no content was added beyond title, show "No data"
  if (content.length === 1) {
    content.push({
      text: 'No data',
      style: 'narrative',
      margin: [0, 0, 0, 8]
    });
  }

  return content;
};
